// showRealName: 跨境订单额外展示下单实名信息(姓名/身份证号)
const getConsigneeSchema = (data = {}, showRealName = false) => {
  const schema = [
    {
      type: 'span',
      label: '收货人',
      value: data.full_name,
    },
    {
      type: 'span',
      label: '地址',
      value: data.user_address,
    },

    {
      type: 'span',
      label: '手机号码',
      value: data.user_phone,
    },
  ];

  if (showRealName) {
    schema.push(
      {
        type: 'span',
        label: '实名姓名',
        value: data.payer_name,
      },
      {
        type: 'span',
        label: '身份证号',
        value: data.payer_id_no,
      }
    );
  }

  return schema;
}

const getBuyerSchema = (data = {}) => [
  {
    type: 'span',
    label: '会员',
    value: data.member_name,
  },
  {
    type: 'span',
    label: '会员序列号',
    value: data.serial_code,
  },

  {
    type: 'span',
    label: '分销商',
    value: data.shop_name,
    className:'conspicuous-bold'
  },
  {
    type: 'span',
    label: '下单时间',
    value: data.add_time,
  },
  {
    type: 'span',
    label: '买家备注',
    value: data.order_remark,
  },
];

const getPaySchema = (data = {}) => [
  {
    type: 'span',
    label: '付款方式',
    value: data.payment_code,
  },
  {
    type: 'span',
    label: '付款时间',
    value: data.pay_time,
  },

  {
    type: 'span',
    label: '支付单号',
    value: data.trade_no,
  },
  {
    type: 'span',
    label: '商品总额',
    value: data.goods_total,
    className:'conspicuous-bold'
  },
  {
    type: 'span',
    label: '优惠抵扣',
    value: data.coupon_money,
  },
  {
    type: 'span',
    label: '包装费',
    value: data.packing,
  },
  {
    type: 'span',
    label: '总重量',
    value: data.weight_total,
  },
  {
    type: 'span',
    label: '快递公司',
    value: data.express_name,
  },
  {
    type: 'span',
    label: '运费',
    value: data.freight,
  },
  {
    type: 'span',
    label: data.amount_label,
    value: data.order_total,
    className:'conspicuous-bold'
  },
];

const getPurchaserSchema = (data = {}) => {
  console.log(data)
  return[
    {
      type: 'span',
      label: '买手姓名',
      value: data.buyer_name,
    },
    {
      type: 'span',
      label: '入驻时间',
      value: data.created_at,
    },

    {
      type: 'span',
      label: '所属分类',
      value: data.class_name,
    },
    {
      type: 'span',
      label: '关联商品',
      value: data.goods_num,
    },
    {
      type: 'span',
      label: '关联供应商',
      value: data.supplier_num,
    },
  ];
}

const getSaleSchema = (data = {}) => [
  {
    type: 'span',
    label: '售出总件数',
    value: data.sale_number,
  },
  {
    type: 'span',
    label: '总采购成本',
    value: data.cost_price,
  },

  {
    type: 'span',
    label: '总交易额',
    value: data.sale_price,
  },
  {
    type: 'span',
    label: '总毛利额',
    value: data.profit_price,
  },
  {
    type: 'span',
    label: '总毛利率',
    value: data.profit,
  },
];

export { getConsigneeSchema, getBuyerSchema, getPaySchema, getPurchaserSchema, getSaleSchema };
